import { render, staticRenderFns } from "./AllocationOutList.vue?vue&type=template&id=a54a0704&scoped=true"
import script from "./AllocationOutList.vue?vue&type=script&lang=js"
export * from "./AllocationOutList.vue?vue&type=script&lang=js"
import style0 from "./AllocationOutList.vue?vue&type=style&index=0&id=a54a0704&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54a0704",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a54a0704')) {
      api.createRecord('a54a0704', component.options)
    } else {
      api.reload('a54a0704', component.options)
    }
    module.hot.accept("./AllocationOutList.vue?vue&type=template&id=a54a0704&scoped=true", function () {
      api.rerender('a54a0704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/AllocationOutList.vue"
export default component.exports